/**
 * Shared Application Constants
 * Common constants used across the application
 */

/**
 * Empty string constant to avoid magic strings
 */
export const EMPTY_STRING = "";

/**
 * File generation status constants
 * Used to represent the status of report generation processes
 */
export const FILE_GENERATION_STATUS = {
  COMPLETE: "Complete" as const,
  INCOMPLETE: "Incomplete" as const,
  FAILED: "Failed" as const,
  ERROR: "Error" as const,
} as const;
